const BASE_CONST = `EMPLOYEE_STAFF_`;

export const SUBMITTING_GET_EMPLOYEES = 'get_employees';

export const SUBMITTING_GET_OUTLETS = 'get_outlets';

export const SUBMITTING_CREATE_EMPLOYEE = 'create_employee';

export const SUBMITTING_UPDATE_EMPLOYEE = 'update_employee';

export const EMPLOYEE_STAFF_OPEN_RIGHT_COLUMN = `${BASE_CONST}OPEN_RIGHT_COLUMN`;

export const EMPLOYEE_STAFF_CLOSE_RIGHT_COLUMN = `${BASE_CONST}CLOSE_RIGHT_COLUMN`;

export const EMPLOYEE_STAFF_ON_CHANGE_KEYWORD = `${BASE_CONST}ON_CHANGE_KEYWORD`;

export const EMPLOYEE_STAFF_ON_CLICK_INVITE_STAFF = `${BASE_CONST}ON_CLICK_INVITE_STAFF`;

export const EMPLOYEE_STAFF_ON_CLICK_EXPORT = `${BASE_CONST}ON_CLICK_EXPORT`;

export const EMPLOYEE_STAFF_ON_CLICK_ROW = `${BASE_CONST}ON_CLICK_ROW`;

export const EMPLOYEE_STAFF_ON_CLICK_CANCEL = `${BASE_CONST}ON_CLICK_CANCEL`;

export const EMPLOYEE_STAFF_ON_CLICK_ASSIGN_OUTLET = `${BASE_CONST}ON_CLICK_ASSIGN_OUTLET`;

export const EMPLOYEE_STAFF_ON_CANCEL_ASSIGN_OUTLET = `${BASE_CONST}ON_CANCEL_ASSIGN_OUTLET`;

export const EMPLOYEE_STAFF_ON_CONFIRM_ASSIGN_OUTLET = `${BASE_CONST}ON_CONFIRM_ASSIGN_OUTLET`;

export const EMPLOYEE_STAFF_ON_CANCEL_DELETE_EMPLOYEE = `${BASE_CONST}ON_CANCEL_DELETE_EMPLOYEE`;

export const EMPLOYEE_STAFF_ON_CONFIRM_DELETE_EMPLOYEE = `${BASE_CONST}ON_CONFIRM_DELETE_EMPLOYEE`;

export const EMPLOYEE_STAFF_ON_CLICK_DELETE_EMPLOYEE = `${BASE_CONST}ON_CLICK_DELETE_EMPLOYEE`;

export const EMPLOYEE_STAFF_ON_SUBMIT_FORM = `${BASE_CONST}ON_SUBMIT_FORM`;

export const EMPLOYEE_STAFF_LIST_STAFF_REQUEST = `${BASE_CONST}LIST_STAFF_REQUEST`;

export const EMPLOYEE_STAFF_LIST_OUTLET_REQUEST = `${BASE_CONST}LIST_OUTLET_REQUEST`;

export const EMPLOYEE_STAFF_LIST_ROLES_REQUEST = `${BASE_CONST}LIST_ROLES_REQUEST`;

export const EMPLOYEE_STAFF_LIST_PERMISSIONS_REQUEST = `${BASE_CONST}LIST_PERMISSIONS_REQUEST`;

export const EMPLOYEE_STAFF_PAGE_REQUEST = `${BASE_CONST}PAGE_REQUEST`;

export const EMPLOYEE_STAFF_SET_OUTLETS = `${BASE_CONST}SET_OUTLETS`;

export const EMPLOYEE_STAFF_SET_EMPLOYEES = `${BASE_CONST}SET_EMPLOYEES`;

export const EMPLOYEE_STAFF_SET_ROLES = `${BASE_CONST}SET_ROLES`;

export const EMPLOYEE_STAFF_SET_SUBMITTING = `${BASE_CONST}SET_SUBMITTING`;

export const EMPLOYEE_STAFF_SET_EMPLOYEE_DETAIL = `${BASE_CONST}SET_EMPLOYEE_DETAIL`;

export const EMPLOYEE_STAFF_SET_RESEND_CAPTCHA_EMAIL = `${BASE_CONST}SET_RESEND_CAPTCHA_EMAIL`;

export const EMPLOYEE_STAFF_SET_CAN_ACCESS_ROLE = `${BASE_CONST}SET_CAN_ACCESS_ROLE`;

export const EMPLOYEE_STAFF_SHOW_ASSIGN_OUTLET_MODAL = `${BASE_CONST}SHOW_ASSIGN_OUTLET_MODAL`;

export const EMPLOYEE_STAFF_HIDE_ASSIGN_OUTLET_MODAL = `${BASE_CONST}HIDE_ASSIGN_OUTLET_MODAL`;

export const EMPLOYEE_STAFF_SHOW_EMPLOYEE_DELETE_MODAL = `${BASE_CONST}SHOW_EMPLOYEE_DELETE_MODAL`;

export const EMPLOYEE_STAFF_SET_PIN_REQUIRED_MODAL = `${BASE_CONST}SET_PIN_REQUIRED_MODAL`;

export const EMPLOYEE_STAFF_HIDE_EMPLOYEE_DELETE_MODAL = `${BASE_CONST}HIDE_EMPLOYEE_DELETE_MODAL`;

export const EMPLOYEE_STAFF_SHOW_RESEND_CAPTCHA_MODAL = `${BASE_CONST}SHOW_RESEND_CAPTCHA_MODAL`;

export const EMPLOYEE_STAFF_HIDE_RESEND_CAPTCHA_MODAL = `${BASE_CONST}HIDE_RESEND_CAPTCHA_MODAL`;

export const EMPLOYEE_STAFF_SHOW_PIN_REQUIRED_MODAL = `${BASE_CONST}SHOW_PIN_REQUIRED_MODAL`;

export const EMPLOYEE_STAFF_HIDE_PIN_REQUIRED_MODAL = `${BASE_CONST}HIDE_PIN_REQUIRED_MODAL`;

export const EMPLOYEE_STAFF_ON_CLICK_RESEND_INVITATION = `${BASE_CONST}ON_CLICK_RESEND_INVITATION`;

export const EMPLOYEE_STAFF_ON_CANCEL_RESEND = `${BASE_CONST}ON_CANCEL_RESEND`;

export const EMPLOYEE_STAFF_ON_CLICK_RESEND_WITH_VALID_CAPTCHA = `${BASE_CONST}ON_CLICK_RESEND_WITH_VALID_CAPTCHA`;

export const EMPLOYEE_STAFF_RESEND_INVITATION = `${BASE_CONST}RESEND_INVITATION`;

export const EMPLOYEE_STAFF_SHOW_PURCHASE_STAFF_SLOT_MODAL = `${BASE_CONST}SHOW_PURCHASE_STAFF_SLOT_MODAL`;

export const EMPLOYEE_STAFF_HIDE_PURCHASE_STAFF_SLOT_MODAL = `${BASE_CONST}HIDE_PURCHASE_STAFF_SLOT_MODAL`;

export const EMPLOYEE_STAFF_SHOW_REACTIVATE_STAFF_MODAL = `${BASE_CONST}SHOW_REACTIVATE_STAFF_MODAL`;

export const EMPLOYEE_STAFF_HIDE_REACTIVATE_STAFF_MODAL = `${BASE_CONST}HIDE_REACTIVATE_STAFF_MODAL`;

export const EMPLOYEE_STAFF_SHOW_REACTIVATE_STAFF_NO_SLOT_MODAL = `${BASE_CONST}SHOW_REACTIVATE_STAFF_NO_SLOT_MODAL`;

export const EMPLOYEE_STAFF_HIDE_REACTIVATE_STAFF_NO_SLOT_MODAL = `${BASE_CONST}HIDE_REACTIVATE_STAFF_NO_SLOT_MODAL`;

export const EMPLOYEE_STAFF_ACTIVE_STAFF_LIST_REQUEST = `${BASE_CONST}ACTIVE_STAFF_LIST_REQUEST`;

export const EMPLOYEE_STAFF_ON_CHANGE_STATUS = `${BASE_CONST}ON_CHANGE_STATUS`;

export const EMPLOYEE_STAFF_ON_CLICK_ADD_STAFF_SLOT = `${BASE_CONST}ON_CLICK_ADD_STAFF_SLOT`;

export const EMPLOYEE_STAFF_GET_FEATURE_PRICE = `${BASE_CONST}GET_FEATURE_PRICE`;

export const EMPLOYEE_STAFF_SET_FEATURE_PRICE = `${BASE_CONST}SET_FEATURE_PRICE`;

export const EMPLOYEE_STAFF_VERIFY_ADD_STAFF_SLOT = `${BASE_CONST}VERIFY_ADD_STAFF_SLOT`;

export const EMPLOYEE_STAFF_SET_SLOT_DETAIL = `${BASE_CONST}SET_SLOT_DETAIL`;

export const EMPLOYEE_STAFF_SHOW_DEACTIVATE_STAFF_MODAL = `${BASE_CONST}SHOW_DEACTIVATE_STAFF_MODAL`;

export const EMPLOYEE_STAFF_HIDE_DEACTIVATE_STAFF_MODAL = `${BASE_CONST}HIDE_DEACTIVATE_STAFF_MODAL`;

export const EMPLOYEE_STAFF_ON_DEACTIVATE_STAFF = `${BASE_CONST}ON_DEACTIVATE_STAFF`;

export const EMPLOYEE_STAFF_ON_CLICK_REACTIVATE_BUTTON = `${BASE_CONST}ON_CLICK_REACTIVATE_BUTTON`;

export const EMPLOYEE_STAFF_ASSIGN_EMPLOYEE_TO_SLOT = `${BASE_CONST}ASSIGN_EMPLOYEE_TO_SLOT`;

export const EMPLOYEE_STAFF_SET_AVAILABLE_SLOTS = `${BASE_CONST}SET_AVAILABLE_SLOTS`;

export const EMPLOYEE_STAFF_SET_ASSIGNED_EMPLOYEE = `${BASE_CONST}SET_ASSIGNED_EMPLOYEE`;

export const EMPLOYEE_STAFF_ON_CLICK_PAY_TO_REACTIVATE = `${BASE_CONST}ON_CLICK_PAY_TO_REACTIVATE`;

export const EMPLOYEE_STAFF_SET_PENDING_BILLING = `${BASE_CONST}SET_PENDING_BILLING`;

export const EMPLOYEE_STAFF_STOP_RENEWAL_SLOT = `${BASE_CONST}STOP_RENEWAL_SLOT`;

export const EMPLOYEE_STAFF_SHOW_STOP_RENEWAL_MODAL = `${BASE_CONST}SHOW_STOP_RENEWAL_MODAL`;

export const EMPLOYEE_STAFF_HIDE_STOP_RENEWAL_MODAL = `${BASE_CONST}HIDE_STOP_RENEWAL_MODAL`;

export const EMPLOYEE_STAFF_ON_CLICK_LINK_STOP_RENEWAL = `${BASE_CONST}ON_CLICK_LINK_STOP_RENEWAL`;

export const EMPLOYEE_STAFF_SHOW_PAYMENT_GATEWAY_ERROR_MODAL = `${BASE_CONST}SHOW_PAYMENT_GATEWAY_ERROR_MODAL`;

export const EMPLOYEE_STAFF_HIDE_PAYMENT_GATEWAY_ERROR_MODAL = `${BASE_CONST}HIDE_PAYMENT_GATEWAY_ERROR_MODAL`;

export const EMPLOYEE_STAFF_DEACTIVATE_SET_ERROR_MESSAGE = `${BASE_CONST}DEACTIVATE_SET_ERROR_MESSAGE`;
